import Vue from 'vue';
import VueRouter from 'vue-router';
import './RegisterProjectComponents';
Vue.use(VueRouter);

const store = require('./store');
const Routes = require('./Routes');
const routes = Routes.routes;
const data = require('../data');
const elementsTracking = require('../../../viscomjs/analytics/elementsTracking');
const body = document.body;

const sharedState = (() => {
    const SharedState = require('../vueToAnim/SharedState');
    return SharedState.instance();
})();

const scrollTo = (element, to, duration) => {
    const start = element.scrollTop;
    const change = to - start;
    const increment = 20;
    let currentTime = 0;

    const animateScroll = function() {
        currentTime += increment;
        element.scrollTop = Math.easeInOutQuad(currentTime, start, change, duration);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
};

Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

module.exports.init = () => {
    return new Vue({
        el: '#app',
        store,
        router: new VueRouter({
            routes,
            mode: 'abstract'
        }),
        data: {
            data: data
        },
        created() {
            // Setup scrollBehavior
            // this.$router.options.scrollBehavior = scrollBehavior.bind(this.$router);

            if (!this.$router.currentRoute) {
                this.$router.push('/');
                return;
            }
            const cur = this.$router.currentRoute;
            if (this.checkRouteExistence(cur)) {
                this.updateDocState(cur);
                return;
            }

            if (cur.fullPath !== '/') this.$router.push('/404');
        },
        mounted() {
            elementsTracking.init(this.$el);

            const AnimationController = require('../vueToAnim/AnimationController');
            this._animationController = AnimationController();
            this._animationController.on('transitionMiddle', this.update, this);
            this._animationController.setup();
            this._animationController.startCover();

            this.$router.replace('/');
        },
        watch: {
            $route(to, from) {
                let data;
                let data2;
                let tl;
                if (this.checkRouteExistence(to)) {
                    if (from.name === 'question') {
                        scrollTo(document.documentElement, 0, 450);
                    }

                    switch (to.name) {
                        case 'cover':
                            this._animationController.startCover(from.name);
                            break;

                        case 'question':
                            data2 = Routes.getLocationData(parseInt(to.params.index));
                            data = Routes.getQuestionData(parseInt(to.params.index), parseInt(to.params.questionIndex));
                            tl = this._animationController.gotoLocation(data2.id, from.name);
                            this._animationController.prepareShortStory(data.id, tl, sharedState.lastAnswerName);
                            break;

                        case 'answer':
                            data = Routes.getQuestionData(parseInt(to.params.index), parseInt(to.params.questionIndex));
                            this._animationController.showShortStory(data.id, sharedState.lastAnswerName);
                            break;

                        case 'results':
                            // data = this.$store.getters['quiz/result'];
                            this._animationController.gotoResults(from.name);
                            break;
                    }

                    return;
                }
                this.$router.push('/404');
            }
        },
        methods: {
            checkRouteExistence(route) {
                return route.matched && route.matched.length > 0;
            },
            update() {
                this.updateDocState(this.$router.currentRoute);
            },
            updateDocState(cur) {
                const data = Routes.getLocationData(parseInt(cur.params.index));
                body.dataset.curRouteName = cur.name || '';
                body.dataset.curRouteId = data ? data.id : '';
            }
        }
    });
};
